import envs from "../envs";
import { createRouteConfig } from "../../utils";

const cartilhas = [
  {
    id: "CICF",
    fisicalPath: `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/PessoaFisica/Imobiliario/Caixa-Seguradora-Cartilha-Comprar-Imovel-Comercial-que-esta-Financiado.pdf`,
    idNewCon: "94",
  },
];

const checkList = [
  {
    id: "CKL-CIF",
    fisicalPath: `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imóvel-que-esta-Financiado.pdf`,
  },
  {
    id: "CKL-DTIF",
    fisicalPath: `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Declaracao-de-Transferencia-de-Imovel-Foreiro.pdf`,
  },
  {
    id: "CKL-SGI",
    fisicalPath: `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Substituicao-de-Garantia-Imovel.pdf`,
  },
];

export default createRouteConfig(
  [...cartilhas, ...checkList],
  ({ id: rotaPrincipal, fisicalPath, idNewCon }) => ({
    rotaPrincipal,
    fisicalPath,
    outrasRotas: idNewCon ? [`cons/${idNewCon}`] : null,
  }),
  "CNP-CONS"
);
